<template>
    <div v-if="(discountsWithoutCoupon?.length ?? 0) > 0" class="discounts-box" >
        <div class="total-box" @click="showMore = !showMore">
            <div class="title">{{ $t('cart.discount_title') }}</div>
            <div class="details">
                <div class="total">
                    {{ total }}
                </div>
                <i class="icon" :class="[showMore ? 'icon-icon_arrow-up' : 'icon-icon_arrow-down']" />
            </div>
        </div>
        <div v-if="showMore" class="detail-box">
            <div v-for="(item, index) in discountsWithTextInfo" :key="index" class="detail-item">
                <div class="name">{{ item.title }}</div>
                <div class="value">-{{ currency }} {{ item.details }}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { getDiscounts, getI18nPromotionTextMap } from '@/utils/business';
import { sum } from '@/utils/number';
import { IPromotion, TGetDiscountsResult } from '@reolink-cloud/interface';
import Vue, { PropType } from 'vue';

export default Vue.extend({
    props: {
        discounts: Array as PropType<IPromotion[]>,
        currency: String
    },
    data() {

        return {
            showMore: false
        };

    },
    computed: {
        discountsWithoutCoupon(): IPromotion[] {

            if ( !this.discounts ) return [];

            return this.discounts.filter( item => item.key !== 'cloud_coupon' );

        },
        total(): string {

            if ( !this.discounts ) return '';

            return `-${this.currency} ${sum( ...this.discountsWithoutCoupon.map( item => parseFloat( item.discount ))).toFixed( 2 )}`;

        },
        discountsWithTextInfo(): TGetDiscountsResult {

            return getDiscounts( getI18nPromotionTextMap( this.$i18n ), this.discountsWithoutCoupon );

        }
    },
});
</script>

<style lang="less" scoped>
.discounts-box{
    padding: 12px 0;
    .total-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        .title{
            font-size: 16px;
        }
        .details{
            display: flex;
            align-items: center;
            .total{
                font-size: 16px;
                color: @red_5;
                margin-right: 4px;
                font-weight: 600;
            }
            .icon{
                font-size: 11px;
            }
        }
    }
    .detail-box{
        background-color: @bg_01;
        padding: 12px;
        margin-top: 6px;
        border-radius: @border-radius-level-small;
        .mobile({
            background-color: @bg_02;
        });
        .detail-item{
            display: flex;
            justify-content: space-between;
            .name{
                font-size: 14px;
            }
            .value{
                font-size: 14px;
                font-weight: 600;
                color: @red_5;
            }
        }
    }
}
</style>
